<app-dialog
  #dialog
  [key]="'modal-business-case-upload'"
  [action]="'upload-business-case'"
  [headerTheme]="'simple'"
  [title]="'Upload Business Case'"
  [maxWidth]="'500px'">
  <div class="p-4">
    <!-- Company Information -->
    <div class="mb-4" *ngIf="company">
      <h5 class="mb-2">{{ company.displayName }}</h5>
      <p class="text-muted mb-0">CNPJ: {{ company.cnpj }}</p>
    </div>

    <!-- Existing File Warning -->
    <div class="alert alert-warning mb-4" *ngIf="hasExistingFile">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="pi pi-exclamation-triangle me-2"></i>
          <span
            >Esta empresa já possui um business case. O upload de um novo arquivo substituirá
            completamente a versão atual.</span
          >
        </div>
        <app-button
          [label]="'Download Atual'"
          [icon]="'pi pi-download'"
          [theme]="'dashed'"
          [size]="'small'"
          (sendButtonClick)="downloadCurrentFile()">
        </app-button>
      </div>
    </div>

    <!-- File Upload -->
    <div class="mb-4">
      <app-document-attachment
        [documents]="documents"
        [required]="true"
        [maxFiles]="1"
        [label]="'Business Case'"
        [acceptedFormats]="['.pptx']"
        [emptyLabel]="'Selecione um arquivo PPTX'"
        [showLoadingSpinner]="false"
        (sendDocument)="onFileSelected($event)"
        (sendRemoveFile)="onRemoveFile($event)">
      </app-document-attachment>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="isLoading"
        [loadingText]="'Fazendo upload...'"
        [label]="'Upload'"
        (sendButtonClick)="submitUpload()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
